import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';

/** SS-21612: согласованный контракт до его появления в backend OpenAPI. */
export interface IntegrationOzonPayCredentials {
    /** ID токена Ozon Pay. */
    access_key: string;
    /** Секретный ключ API. */
    secret_key: string;
}

const ozonPayApi = createApi({
    name: 'entities/integration/api/ozonPayApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            saveCredentials: builder.mutation<void, IntegrationOzonPayCredentials>({
                query: (body) => {
                    return {
                        url: '/integrations/type/ozon-pay/credentials',
                        method: 'POST',
                        body,
                    };
                },
            }),
        };
    },
});

export const saveIntegrationOzonPayCredentials = ozonPayApi.endpoints.saveCredentials.mutate;
